import Grid from '@material-ui/core/Grid'
import { Emoji } from 'emoji-mart'
import User from 'EurestoClass/User'
import Activite from 'EurestoTemplate/Configuration/Activite'
import Fonction from 'EurestoTemplate/Configuration/Fonction'
import Profil from 'EurestoTemplate/Configuration/Profil'
import Utilisateur from 'EurestoTemplate/Configuration/Utilisateur'
import InfoTiers from 'EurestoTemplate/CRM/InfoTiers'
import InfoTiersDonnees from 'EurestoTemplate/CRM/InfoTiersDonnees'
import Famille from 'EurestoTemplate/Gestion/Famille'
import Rubrique from 'EurestoTemplate/Gestion/Rubrique'
import Classeur from 'EurestoTemplate/Messagerie/Classeur'
import ConfigurationMessagerie from 'EurestoTemplate/Messagerie/Configuration'
import Flag from 'EurestoTemplate/Messagerie/Flag'
import MsgInfoTiers from 'EurestoTemplate/Messagerie/InfoTiers'
import MsgInfoTiersDonnees from 'EurestoTemplate/Messagerie/InfoTiersDonnees'
import Classe from 'EurestoTemplate/Pedagogie/Classe'
import Eleve from 'EurestoTemplate/Pedagogie/Eleve'
import Exercice from 'EurestoTemplate/Pedagogie/Exercice'
import Formation from 'EurestoTemplate/Pedagogie/Formation'
import ReservationCarcasse from 'EurestoTemplate/Reservation/Carcasse'
import ReservationMessage from 'EurestoTemplate/Reservation/Message'
import ReservationProduit from 'EurestoTemplate/Reservation/Produit'
import ReservationService from 'EurestoTemplate/Reservation/Service'
import ReservationTable from 'EurestoTemplate/Reservation/Table'
import ReservationTableCategorie from 'EurestoTemplate/Reservation/TableCategorie'
import moment from 'moment'
import React from 'react'








moment.locale('fr')

let license = {
  inactive: 0,
  active: 1,
}

let access = {
  EURESTO: 1,
  GROUPE: 3,
  ETABLISSEMENT: 4,
  USER_GROUPE: 5,
  USER_ETS: 6,
  CLIENT_RESA: 7,
  CLIENT: 8,
  PUBLIC: 9
}

let lang = {
  FR: 1,
  EN: 2
}

let typeAction = {
  CreationDossier: 1,
  ModificationDossier: 2,
  FermetureDossier: 3,

  AppelEnvoi: 10,
  AppelRecu: 11,

  EmailEnvoi: 20,
  EmailRecu: 21,

  Message: 30,
  Upload: 31,
  MessagePrive: 32,
  AssistanceLogicielEuresto: 34,

  SmsEnvoi: 40,
  SmsRecu: 41,

  Newsletter: 50
}

let text2img = {
  Assistance: 'user-md',
  Config: 'cogs',
  Prospect: 'suitcase',
  Devis: 'file',
  Archive: 'cogs',
  Administrative: 'cogs',
  1: 'volume-control-phone',
  2: 'phone',
  20: 'plus',
  23: 'bug',
  21: 'envelope',
  25: 'envelope',
  22: 'envelope-open',
  26: 'envelope',
  3: 'fax',
  28: 'bell',
  4: 'sticky-note',
  8: 'comment',
  24: 'comments',
  27: 'upload',
}

let relation = {
  type_relation_etablissement_client: 101,
  type_relation_etablissement_utilisateur: 102,
  type_relation_groupe_utilisateur: 103,
  type_relation_utilisateur_client: 201,
  type_relation_groupe_etablissement: 301,
  type_relation_distributeur_etablissement: 400 //TODO NON GÉRÉ
}

let broadcastAction = {
  add: 1,
  update: 2,
  delete: 3,
  replace: 4
}

let typeSaisie = {
  SaisieLibre: 1,
  SaisieLibreHTML: 37,
  SaisieLibreBool: 2,
  SaisieLibreLink: 31,
  SaisieLibreUpload: 35,
  SaisieLibreMultipleLink: 32,
  SaisieLibreMultiple: 12,
  SaisieLibreMultipleBool: 13,
  SaisieLibreMultipleUpload: 36,
  Bool: 3,
  ComboSimple: 4,
  ComboSimpleSaisieLibre: 5,
  ComboSimpleEntier: 6,
  ComboSimpleBool: 7,
  ComboSimpleUpload: 34,
  ComboMulti: 8,
  ComboMultiSaisieLibre: 9,
  ComboMultiEntier: 10,
  ComboMultiBool: 11,
  ComboMultiUpload: 33,
  TextArea: 14,
  Wysiwyg: 15,
  Picture: 16,
  Profil: 17,
  InfoTiersDonnees: 18,
  InputTextBasic: 19,

  Relations: 21,
  Stars: 22,
  Date: 23,
  Adresses: 24,
  Mails: 25,
  Telephones: 26,
  Formulaire: 27,
  Upload: 28,
  PaysNationaliteLangue: 29,
  AutoComplete: 30,
}

let module = {
  COMMUN: 'commun',
  CRM: 'crm',
  RESTAURANT: 'restaurant',
  GESTION: 'gestion',
  FACTURATION: 'facturation',
  FIDELITE: 'fidelite',
  MESSAGERIE: 'messagerie',
  SDD: 'sdd',
  INTERFACE: 'interface',
  PRIVEE: 'privee',
  CONFIGURATION: 'configuration',
  SELLSY: 'sellsy',
  PEDAGOGIE: 'pedagogie',
  HOTEL: 'hotel',
}

let donnee = {
  document: 'document',
  type_mouvement: 'type_mouvement',
  lieu: 'lieu',
  rubrique: 'rubrique',
  famille: 'famille',
  unite: 'unite',
  allergene: 'allergene',
  info_tiers: 'info_tiers',
  categorie_unite: 'categorie_unite',
  info_tiers_donnees: 'info_tiers_donnees',
  type_produit: 'type_produit',
  taux_tva: 'taux_tva',
  type_tva: 'type_tva',
  type_unite: 'type_unite',

  produit: 'produit',
  planning: 'planning',
  table: 'table',
  table_categorie: 'table_categorie',
  carcasse: 'carcasse',
  motif_annulation: 'motif_annulation',
  motif_refus: 'motif_refus',
  requete: 'requete',

  onglet: 'onglet',
  type_saisie: 'type_saisie',

  relation: 'relation',
  groupe_utilisateur: 'groupe_utilisateur',
  dossier: 'dossier',

  facture: 'facture',
  ligne_facture: 'ligne_facture',
  pax: 'pax',
  pdv: 'pdv',

  classe: 'classe',
  eleve: 'eleve',
  formation: 'formation',
  exercice: 'exercice',

  activite: 'activite',
  civilite: 'civilite',
  module: 'module',
  fonction: 'fonction',
  langue: 'langue',
  mail_configuration: 'mail_configuration',
  pays: 'pays',
  profil: 'profil',
  region_tva: 'region_tva',
  sms_configuration: 'sms_configuration',
  type_archivage: 'type_archivage',

  groupe: 'groupe',
  etablissement: 'etablissement',
  utilisateur: 'utilisateur',
  client: 'client',

  classeur: 'classeur',
  type_action: 'type_action',
  notification: 'notification',
  action: 'action',
  qualite: 'qualite',

  configuration: 'configuration',

  upload: 'upload',
  type_client: 'type_client',
  type_media: 'type_media',
  media: "media",
  enseigne: 'enseigne',

  filtre: 'filtre',

  type_messagerie: 'type_messagerie',
  message: 'message',

  service: 'service',
  interface: 'interface',
  flag: 'flag',
  reservation: 'reservation',

  option: 'option',
  template: 'template',
  template_type: 'template_type',
  sms: 'sms',
  messagerie: 'messagerie'
}

let dataType = {
  euresto: 5,
  groupe: 5,
  etablissement: 5,
  user: 4,
  commun: 5
}

let usefullObjectStatic = {
  [module.COMMUN + '-' + donnee.pays]: {
    type: [{ id: 0, libelle: EurestoI18n.t('commun:Inactif') }, { id: 1, libelle: EurestoI18n.t('commun:Actif') }]
  },
  [module.COMMUN + '-' + donnee.langue]: {
    type: [{ id: 0, libelle: EurestoI18n.t('commun:Inactif') }, { id: 1, libelle: EurestoI18n.t('commun:Actif') }]
  },
  [module.GESTION + '-' + donnee.rubrique]: {
    type: [{ id: 1, libelle: EurestoI18n.t('Rubrique produit') }, { id: 2, libelle: EurestoI18n.t('Rubrique cave') }]
  },
  [module.GESTION + '-' + donnee.famille]: {
    type: [
      { id: 1, libelle: EurestoI18n.t('Produit en stock') },
      { id: 2, libelle: EurestoI18n.t('Région/Sous-région vin') },
      { id: 3, libelle: EurestoI18n.t('Fiche technique de base') }
    ]
  },
  [module.COMMUN + '-' + donnee.media]: {
    type: [{
      value: 85,
      label: 'Version Euresto',
      condition: (() => User.TypeAccess.get(Constants.access.EURESTO))
    }, {
      value: 80,
      label: 'Patch Euresto 32.042.0',
      condition: (() => User.TypeAccess.get(Constants.access.EURESTO))
      }, {
        value: 81,
      label: 'Patch Euresto 32.042.1',
      condition: (() => User.TypeAccess.get(Constants.access.EURESTO))
      }, {
      value: 70,
      label: 'Patch Mobile',
      condition: (() => User.TypeAccess.get(Constants.access.EURESTO))
    }, {
      value: 99,
      label: 'Divers'
    }, {
      value: 4,
      label: 'Archive Fiscale',
      condition: (() => !User.TypeAccess.get(Constants.access.EURESTO))
    }]
  },
  [module.CRM + '-' + donnee.civilite]: {
    type: [{ id: 1, libelle: EurestoI18n.t('Civilité') }, { id: 2, libelle: EurestoI18n.t('Forme Juridique') }]
  },
  [module.CRM + '-' + donnee.info_tiers]: {
    entite: [
      { id: 1, libelle: EurestoI18n.t('Personne') },
      { id: 2, libelle: EurestoI18n.t('Entité') },
      {
        id: 4,
        libelle: EurestoI18n.t('Établissement'),
        condition: (() => (User.TypeAccess.get(access.EURESTO)))
      },
      {
        id: 5,
        libelle: EurestoI18n.t('Groupe'),
        condition: (() => (User.TypeAccess.get(access.EURESTO)))
      }
    ]
  },
  [module.CRM + '-' + donnee.type_saisie]: {
    autorisation: [{ id: 1, libelle: EurestoI18n.t('Tous'), default: true }, {
      id: 0, libelle: EurestoI18n.t('Euresto'), condition: (() => (User.TypeAccess.get(access.EURESTO)))
    }]
  },
  [module.CRM + '-' + donnee.onglet]: {
    type_contact: [
      {
        id: 1, libelle: EurestoI18n.t('Client')
      },
      {
        id: 2,
        libelle: EurestoI18n.t('Etablissement'),
        condition: (() => (User.TypeAccess.get(access.EURESTO)))
      },
      {
        id: 3,
        libelle: EurestoI18n.t('Groupe'),
        condition: (() => (User.TypeAccess.get(access.EURESTO)))
      }
    ]
  },
  [module.MESSAGERIE + '-' + donnee.configuration]: {
    connection: [
      {
        id: 1,
        libelle: (<div className={'EurestoPrimary'} style={{ borderRadius: 50, height: 15, width: 15 }} />)
      },
      {
        id: 0,
        libelle: (<div className={'EurestoError'} style={{ borderRadius: 50, height: 15, width: 15 }} />)
      },
      /*{
        id: 1,
        libelle: (<i className={'EurestoPrimary--text icon-07'} style={{fontSize: 10}}/>)
      },
      {
        id: 0,
        libelle: (<i className={'EurestoError--text icon-07'} style={{fontSize: 10}}/>)
      },*/
    ]
  },
}

let dataObject = {
  [module.PRIVEE + '-' + donnee.dossier]: {
    websocket: true,
    modifSearch: 'key_dossier',
    orderBy: ['date_modification desc'],
  },
  [module.MESSAGERIE + '-' + donnee.message]: {
    websocket: true,
    modifSearch: 'id',
    orderBy: ['date_modification desc'],
  },
  [module.MESSAGERIE + '-' + donnee.configuration]: {
    template: ConfigurationMessagerie,
    websocket: true,
    orderBy: ['libelle'],
    modifSearch: 'id',
    requete: {
      get: {
        action: 'get',
        arg: ['id'],
      },
    },
    grid: [
      {
        header: EurestoI18n.t('commun:Id'),
        accessor: 'id',
        show: false,
      }, {
        header: '',
        accessor: 'connection_ok',
        link: false,
        width: 20,
        object: usefullObjectStatic[module.MESSAGERIE + '-' + donnee.configuration].connection
      }, {
        header: EurestoI18n.t('commun:Messagerie'),
        accessor: 'libelle',
      }, {
        header: EurestoI18n.t('commun:Type Messagerie'),
        accessor: 'type_messagerie_id',
        link: true,
        object: module.MESSAGERIE + '-' + donnee.type_messagerie
      }
    ]
  },
  [module.CONFIGURATION + '-' + donnee.groupe_utilisateur]: {
    websocket: true,
    orderBy: ['libelle'],
    modifSearch: 'id',
    requete: {
      get: {
        action: 'get',
        arg: ['id'],
      },
    },
  },
  [module.MESSAGERIE + '-' + donnee.message]: {
    websocket: true,
    orderBy: ['date_envoi desc'],
    modifSearch: 'id',
  },
  [module.MESSAGERIE + '-' + donnee.type_messagerie]: {
    websocket: true,
    orderBy: ['libelle'],
    modifSearch: 'id',
  },
  [module.GESTION + '-' + donnee.type_mouvement]: {
    websocket: true,
    orderBy: ['abrege', 'type'],
    modifSearch: 'id',
  },
  [module.GESTION + '-' + donnee.lieu]: {
    websocket: true,
    orderBy: ['abrege', 'situation'],
    modifSearch: 'id',
  },
  [module.GESTION + '-' + donnee.produit]: {
    websocket: true,
    orderBy: ['libelle', 'type'],
    modifSearch: 'id',
  },
  [module.GESTION + '-' + donnee.allergene]: {
    websocket: true,
    orderBy: ['libelle'],
    modifSearch: 'id',
  },
  [module.GESTION + '-' + donnee.rubrique]: {
    template: Rubrique,
    websocket: true,
    orderBy: ['type', 'libelle'],
    modifSearch: 'id',
    requete: {
      get: {
        action: 'get',
        arg: ['id'],
      },
    },
    grid: [
      {
        header: EurestoI18n.t('commun:Id'),
        accessor: 'id',
        show: false,
      }, {
        header: <strong className={'EurestoPrimary EurestoText--text'}
          style={{ display: 'block', width: '100%' }}>{EurestoI18n.t('commun:Rubrique')}</strong>,
        accessor: 'libelle',
      }, {
        header: EurestoI18n.t('commun:Abrégé'),
        accessor: 'abrege',
      }, {
        header: EurestoI18n.t('commun:Type'),
        accessor: 'type',
        link: false,
        object: usefullObjectStatic[module.GESTION + '-' + donnee.rubrique].type
      }
    ]
  },
  [module.GESTION + '-' + donnee.famille]: {
    orderBy: ['type', 'libelle'],
    template: Famille,
    websocket: true,
    modifSearch: 'id',
    requete: {
      get: {
        action: 'get',
        arg: ['id'],
      },
    },
    gridSearch: { famille_id: null },
    grid: [
      {
        header: 'Id',
        accessor: 'id',
        show: false,
      }, {
        header: <strong className={'EurestoPrimary EurestoText--text'}
          style={{ display: 'block', width: '100%' }}>{EurestoI18n.t('commun:Famille')}</strong>,
        accessor: 'libelle',
        showOnSubComponent: false,
      }, {
        header: <strong className={'EurestoPrimary EurestoText--text'}
          style={{ display: 'block', width: '100%' }}>{EurestoI18n.t('commun:Sous-Famille')}</strong>,
        accessor: 'libelle',
        showOnSubComponent: true,
      }, {
        header: EurestoI18n.t('commun:Abrégé'),
        accessor: 'abrege',
      }, {
        header: EurestoI18n.t('commun:Type'),
        accessor: 'type',
        link: false,
        object: usefullObjectStatic[module.GESTION + '-' + donnee.famille].type,
        showOnSubComponent: false,
      }, {
        header: EurestoI18n.t('commun:Taux TVA'),
        accessor: 'type_tva_id',
        link: true,
        object: module.GESTION + '-' + donnee.taux_tva,
        search: { region_id: User && User.Entite.get().type === access.ETABLISSEMENT ? User.Entite.get().region_tva_id : 1 },
      }
    ],
    whenSub: true,
    gridSubComponent: {
      gridObject: module.GESTION + '-' + donnee.famille,
      search: [
        { searchKey: 'famille_id', rowKey: 'id' },
        { searchKey: 'type_tva_id', rowKey: 'type_tva_id', doNotSearch: true }
      ]
    },
  },
  [module.PEDAGOGIE + '-' + donnee.classe]: {
    orderBy: ['actif', 'libelle'],
    template: Classe,
    websocket: true,
    modifSearch: 'id',
    requete: {
      get: {
        action: 'get',
        arg: ['id'],
      },
    },
    gridSearch: { classe_id: null },
    grid: [
      {
        header: 'Id',
        accessor: 'id',
        show: false,
      }, {
        header: <strong className={'EurestoPrimary EurestoText--text'}
          style={{ display: 'block', width: '100%' }}>{EurestoI18n.t('commun:Classe')}</strong>,
        accessor: 'libelle',
        showOnSubComponent: false,
      }, {
        header: <strong className={'EurestoPrimary EurestoText--text'}
          style={{ display: 'block', width: '100%' }}>{EurestoI18n.t('commun:Groupe')}</strong>,
        accessor: 'libelle',
        showOnSubComponent: true,
      }, {
        header: EurestoI18n.t('commun:Année'),
        accessor: 'actif',
        cell: row => {
          return row.original.annee + '/' + moment(row.original.annee + '-01-01').add(1, 'years').format('YYYY')
        },
        showOnSubComponent: false,
      }, {
        header: EurestoI18n.t('commun:Formation'),
        accessor: 'formation_id',
        link: true,
        object: module.PEDAGOGIE + '-' + donnee.formation,
        showOnSubComponent: false,
      }, {
        header: EurestoI18n.t('commun:Crée le'),
        accessor: 'date_creation',
        cell: row => {
          return moment(row.value).format('DD/MM/YY HH:mm')
        }
      }
    ],
    whenSub: true,
    gridSubComponent: {
      gridObject: module.PEDAGOGIE + '-' + donnee.classe,
      search: [
        { searchKey: 'classe_id', rowKey: 'id' },
        { searchKey: 'annee', rowKey: 'annee', doNotSearch: true }
      ]
    },
  },
  [module.PEDAGOGIE + '-' + donnee.formation]: {
    orderBy: ['libelle'],
    template: Formation,
    websocket: true,
    modifSearch: 'id',
    requete: {
      get: {
        action: 'get',
        arg: ['id'],
      },
    },
    grid: [
      {
        header: 'Id',
        accessor: 'id',
        show: false,
      }, {
        header: <strong className={'EurestoPrimary EurestoText--text'}
          style={{ display: 'block', width: '100%' }}>{EurestoI18n.t('commun:Formation')}</strong>,
        accessor: 'libelle',
      }, {
        header: EurestoI18n.t('commun:Abrege'),
        accessor: 'abrege',
      }, {
        header: EurestoI18n.t('commun:Descriptif'),
        accessor: 'descriptif',
      }
    ]
  },
  [module.PEDAGOGIE + '-' + donnee.exercice]: {
    orderBy: ['libelle'],
    template: Exercice,
    websocket: true,
    modifSearch: 'id',
    requete: {
      get: {
        action: 'get',
        arg: ['id'],
      },
    },
    grid: [
      {
        header: 'Id',
        accessor: 'id',
        show: false,
      }, {
        header: <strong className={'EurestoPrimary EurestoText--text'}
          style={{ display: 'block', width: '100%' }}>{EurestoI18n.t('commun:Exercice')}</strong>,
        accessor: 'libelle',
      }, {
        header: EurestoI18n.t('commun:Module'),
        accessor: 'module',
        cell: row => row.value === 'fiche_technique' ? 'Fiche Technique' : ''
      }, {
        header: EurestoI18n.t('commun:Crée le'),
        accessor: 'date_creation',
        cell: row => {
          return moment(row.value).format('DD/MM/YY HH:mm')
        }
      }
    ]
  },
  [module.GESTION + '-' + donnee.unite]: {
    orderBy: ['libelle'],
    websocket: true,
    modifSearch: 'id',
    requete: {
      get: {
        action: 'get',
        arg: ['id'],
      },
    },
    gridSearch: { unite_id: null },
    grid: [
      {
        header: 'Id',
        accessor: 'id',
        show: false,
      }, {
        header: <strong className={'EurestoPrimary EurestoText--text'}
          style={{ display: 'block', width: '100%' }}>{EurestoI18n.t('commun:Unite')}</strong>,
        accessor: 'libelle',
      }, {
        header: EurestoI18n.t('commun:Abrégé'),
        accessor: 'abrege',
      }, {
        header: EurestoI18n.t('gestion:Categorie d\'unité'),
        accessor: 'unite_categorie_id',
        showOnSubComponent: false,
        link: true,
        object: module.GESTION + '-' + donnee.categorie_unite,
      }
    ],
    gridSubComponent: {
      gridObject: module.GESTION + '-' + donnee.unite,
      search: [
        { searchKey: 'unite_id', rowKey: 'id' }
      ]
    },
  },
  [module.GESTION + '-' + donnee.info_tiers_donnees]: {
    orderBy: ['libelle'],
    websocket: true,
    modifSearch: 'id',
  },
  [module.GESTION + '-' + donnee.categorie_unite]: {
    websocket: false,
    modifSearch: 'id',
    //PAS DE MODIFICATION OU D'AJOUT POSSIBLE
    grid: [
      {
        header: 'Id',
        accessor: 'id',
        show: false,
      }, {
        header: <strong className={'EurestoPrimary EurestoText--text'}
          style={{
            display: 'block',
            width: '100%'
          }}>{EurestoI18n.t('commun:Catégorie d\'unité')}</strong>,
        accessor: 'libelle',
      }, {
        header: EurestoI18n.t('commun:Abrégé'),
        accessor: 'abrege',
      },
    ],
  },
  [module.GESTION + '-' + donnee.info_tiers]: {
    orderBy: ['libelle'],
    websocket: true,
    modifSearch: 'id',
  },
  [module.GESTION + '-' + donnee.taux_tva]: {
    orderBy: ['libelle'],
    websocket: true,
    modifSearch: 'type_tva_id',

    requete: {

      get: {
        action: 'get',
        arg: ['type_tva_id', 'region_id'],
      },
    },
    grid: [
      {
        header: 'Id',
        accessor: 'region_id',
        show: false,
      }, {
        header: <strong className={'EurestoPrimary EurestoText--text'}
          style={{ display: 'block', width: '100%' }}>{EurestoI18n.t('commun:Taux TVA')}</strong>,
        accessor: 'libelle',
      },
    ],
  },
  [module.GESTION + '-' + donnee.type_tva]: {

    orderBy: ['libelle'],
    websocket: false,
    modifSearch: 'id',

    requete: {},
  },
  [module.COMMUN + '-' + donnee.interface]: {
    orderBy: ['libelle'],
    websocket: false,
    modifSearch: 'id',
    requete: {},
  },
  [module.GESTION + '-' + donnee.type_produit]: {
    orderBy: ['libelle'],
    websocket: false,
    modifSearch: 'id',
    requete: {},
  },
  [module.GESTION + '-' + donnee.type_unite]: {

    orderBy: ['libelle'],
    websocket: false,
    modifSearch: 'id',

    requete: {},
  },
  [module.CONFIGURATION + '-' + donnee.sms]: {

    orderBy: ['libelle'],
    websocket: false,
    modifSearch: 'id',

    requete: {},
  },

  [module.CRM + '-' + donnee.info_tiers]: {

    orderBy: ['libelle'],
    template: InfoTiers,
    websocket: true,
    modifSearch: 'id',

    requete: {

      get: {
        action: 'get',
        arg: ['id'],
      },
    },
    grid: [
      {
        header: 'Id',
        accessor: 'id',
        show: false,
      }, {
        header: <strong className={'EurestoPrimary EurestoText--text'}
          style={{ display: 'block', width: '100%' }}>{EurestoI18n.t('commun:Critère')}</strong>,
        accessor: 'libelle',
      }, {
        header: EurestoI18n.t('commun:Type de saisie'),
        accessor: 'type_saisie_id',
        link: true,
        object: module.CRM + '-' + donnee.type_saisie
      },
    ],
    subComponentLink: 'information_tiers_id',
    gridSubComponent: {
      gridObject: module.CRM + '-' + donnee.info_tiers_donnees,
      search: [
        { searchKey: 'information_tiers_id', rowKey: 'id' },
        { searchKey: 'actif', rowKey: 'actif', doNotSearch: true },
        { searchKey: 'qualites', rowKey: 'qualites', doNotSearch: true },
        { searchKey: 'type_entite_information', rowKey: 'type_entite_information', doNotSearch: true }
      ]
    },

  },
  [module.CRM + '-' + donnee.info_tiers_donnees]: {
    orderBy: ['libelle'],
    template: InfoTiersDonnees,
    websocket: true,
    modifSearch: 'id',

    requete: {

      get: {
        action: 'get',
        arg: ['id'],
      },
    },
    grid: [
      {
        header: 'Id',
        accessor: 'id',
        show: false,
      }, {
        header: <strong className={'EurestoPrimary EurestoText--text'}
          style={{
            display: 'block',
            width: '100%'
          }}>{EurestoI18n.t('commun:Valeurs du critère')}</strong>,
        accessor: 'libelle',
      },
    ]
  },
  [module.CRM + '-' + donnee.onglet]: {
    orderBy: ['ordre'],
    websocket: true,
    modifSearch: 'id',
  },
  [module.CRM + '-' + donnee.type_saisie]: {
    orderBy: ['libelle'],
    websocket: true,
    modifSearch: 'id',
  },

  [module.CRM + '-' + donnee.relation]: {
    orderBy: ['libelle'],
    websocket: true,
    modifSearch: 'id',
  },

  [module.COMMUN + '-' + donnee.activite]: {

    orderBy: ['libelle'],
    template: Activite,
    websocket: true,
    modifSearch: 'id',

    requete: {

      get: {
        action: 'get',
        arg: ['id'],
      },
    },
    grid: [
      {
        header: 'Id',
        accessor: 'id',
        show: false,
      }, {
        header: <strong className={'EurestoPrimary EurestoText--text'}
          style={{ display: 'block', width: '100%' }}>{EurestoI18n.t('commun:Activité')}</strong>,
        accessor: 'libelle',
      }, {
        header: EurestoI18n.t('commun:Abrégé'),
        accessor: 'abrege',
      }
    ],
  },
  [module.CONFIGURATION + '-' + donnee.etablissement]: {

    orderBy: ['libelle'],
    websocket: true,
    modifSearch: 'id',
    requete: {},
  },
  [module.CONFIGURATION + '-' + donnee.utilisateur]: {
    template: Utilisateur,
    orderBy: ['libelle'],
    websocket: true,
    modifSearch: 'id',
    requete: {

      get: {
        action: 'get',
        arg: ['id'],
      },
    },
    grid: [{
      header: 'Id',
      accessor: 'id',
      show: false,
    }, {
      header: <strong className={'EurestoPrimary EurestoText--text'}
        style={{ display: 'block', width: '100%' }}>{EurestoI18n.t('commun:Nom')}</strong>,
      accessor: 'libelle',
    }, {
      header: <strong className={'EurestoPrimary EurestoText--text'}
        style={{ display: 'block', width: '100%' }}>{EurestoI18n.t('commun:Email')}</strong>,
      accessor: 'email',
    }, {
      header: <strong className={'EurestoPrimary EurestoText--text'}
        style={{ display: 'block', width: '100%' }}>{EurestoI18n.t('commun:Portable')}</strong>,
      accessor: 'portable',
    }
    ]
  },
  [module.PEDAGOGIE + '-' + donnee.eleve]: {
    template: Eleve,
    orderBy: ['libelle'],
    websocket: true,
    modifSearch: 'id',
    requete: {

      get: {
        action: 'get',
        arg: ['id'],
      },
    },
    grid: [{
      header: 'Id',
      accessor: 'id',
      show: false,
    }, {
      header: <strong className={'EurestoPrimary EurestoText--text'}
        style={{ display: 'block', width: '100%' }}>{EurestoI18n.t('commun:Login')}</strong>,
      accessor: 'email_identification',
      cell: (row) => row.original.email_identification && row.original.email_identification.split('@') && row.original.email_identification.split('@')[0]
    }, {
      header: <strong className={'EurestoPrimary EurestoText--text'}
        style={{ display: 'block', width: '100%' }}>{EurestoI18n.t('commun:Nom')}</strong>,
      accessor: 'libelle',
    }, {
      header: <strong className={'EurestoPrimary EurestoText--text'}
        style={{ display: 'block', width: '100%' }}>{EurestoI18n.t('commun:Email')}</strong>,
      accessor: 'email',
    }, {
      header: <strong className={'EurestoPrimary EurestoText--text'}
        style={{ display: 'block', width: '100%' }}>{EurestoI18n.t('commun:Portable')}</strong>,
      accessor: 'portable',
    }]
  },
  [module.CRM + '-' + donnee.enseigne]: {
    websocket: true,
    orderBy: ['libelle', 'id'],
    modifSearch: 'id',
  },
  [module.CRM + '-' + donnee.type_client]: {
    websocket: true,
    orderBy: ['libelle', 'id'],
    modifSearch: 'id',
  },
  [module.CRM + '-' + donnee.qualite]: {
    websocket: true,
    orderBy: ['libelle', 'id'],
    modifSearch: 'id',
  },
  [module.COMMUN + '-' + donnee.civilite]: {
    websocket: true,
    orderBy: ['type', 'libelle'],
    modifSearch: 'id',
  },
  [module.SDD + '-' + donnee.classeur]: {
    template: Classeur,
    websocket: true,
    orderBy: ['libelle',],
    modifSearch: 'id',

    requete: {
      get: {
        action: 'get',
        arg: ['id'],
      },
    },
    gridSearch: { classeur_id: null },
    grid: [
      {
        header: 'Id',
        accessor: 'id',
        show: false,
      }, {
        accessor: 'icon',
        width: 20,
        cell: (row) => {
          return <i className={'EurestoPrimary--text fa fa-' + row.value} />
        }
      }, {
        header: <strong className={'EurestoPrimary EurestoText--text'}
          style={{ display: 'block', width: '100%' }}>{EurestoI18n.t('commun:Classeur')}</strong>,
        accessor: 'libelle',
        showOnSubComponent: false
      }, {
        header: <strong className={'EurestoPrimary EurestoText--text'}
          style={{ display: 'block', width: '100%' }}>{EurestoI18n.t('commun:Dossier')}</strong>,
        accessor: 'libelle',
        showOnSubComponent: true
      }
    ],
    whenSub: true,
    subComponentLink: 'classeur_id',
    gridSubComponent: {
      gridObject: module.SDD + '-' + donnee.classeur,
      search: [
        { searchKey: 'classeur_id', rowKey: 'id' },
        { searchKey: 'actif', rowKey: 'actif', doNotSearch: true }
      ]
    },

  },
  [module.SDD + '-' + donnee.flag]: {
    template: Flag,
    websocket: true,
    orderBy: ['libelle',],
    modifSearch: 'id',
    requete: {

      get: {
        action: 'get',
        arg: ['id'],
      },
    },
    grid: [
      {
        header: 'Id',
        accessor: 'id',
        show: false,
      }, {
        accessor: 'icon',
        width: 20,
        cell: (row) => {
          return <Grid container justify={'center'} alignItems={'center'} style={{ height: '100%' }}>
            <Emoji emoji={row.original.icon}
              size={16} /></Grid>
        }
      }, {
        header: <strong className={'EurestoPrimary EurestoText--text'}
          style={{ display: 'block', width: '100%' }}>{EurestoI18n.t('commun:Classeur')}</strong>,
        accessor: 'libelle'
      }
    ],

  },
  [module.COMMUN + '-' + donnee.module]: {

    orderBy: ['libelle'],
    websocket: true,
    modifSearch: 'id',

    requete: {},
  },
  [module.COMMUN + '-' + donnee.fonction]: {

    orderBy: ['type', 'libelle'],
    template: Fonction,

    websocket: true,
    modifSearch: 'id',

    requete: {

      get: {
        action: 'get',
        arg: ['id'],
      },
    },
    grid: [
      {
        header: 'Id',
        accessor: 'id',
        show: false,
      }, {
        header: <strong className={'EurestoPrimary EurestoText--text'}
          style={{ display: 'block', width: '100%' }}>{EurestoI18n.t('commun:Fonction')}</strong>,
        accessor: 'libelle',
      }, {
        header: EurestoI18n.t('commun:type'),
        accessor: 'type',
      }
    ],
  },
  [module.CONFIGURATION + '-' + donnee.template]: {

    orderBy: ['libelle'],

    websocket: true,
    modifSearch: `type`,
    requete: {

      get: {
        action: 'get',
        arg: ['id'],
      },
    },
  },
  [module.COMMUN + '-' + donnee.option]: {
    orderBy: ['libelle'],
    websocket: true,
    modifSearch: 'id',
    requete: {
      get: {
        action: 'get',
        arg: ['id'],
      },
    },
  },
  [module.CONFIGURATION + '-' + donnee.option]: {
    orderBy: ['libelle'],
    websocket: true,
    modifSearch: 'id',
    requete: {
      get: {
        action: 'get',
        arg: ['id'],
      },
    },
  },
  [module.CONFIGURATION + '-' + donnee.langue]: {
    orderBy: ['libelle'],
    websocket: true,
    modifSearch: 'id',
    requete: {
      get: {
        action: 'get',
        arg: ['id'],
      },
    },
  },
  [module.PRIVEE + '-' + donnee.filtre]: {

    orderBy: ['libelle'],

    websocket: true,
    modifSearch: 'id',
    requete: {

      get: {
        action: 'get',
        arg: ['id'],
      },
    },
  },
  [module.CONFIGURATION + '-' + donnee.template_type]: {

    template: ReservationMessage,
    orderBy: ['libelle'],

    websocket: true,
    modifSearch: 'id',
    requete: {
      get: {
        action: 'get',
        arg: ['id'],
      }
    },
    grid: [
      {
        header: 'Id',
        accessor: 'id',
        show: false,
      }, {
        header: <strong className={'EurestoPrimary EurestoText--text'}
          style={{ display: 'block', width: '100%' }}>{EurestoI18n.t('commun:Type email')}</strong>,
        accessor: 'libelle',
      },
    ],
  },
  [module.COMMUN + '-' + donnee.langue]: {

    orderBy: ['id'],
    websocket: true,
    modifSearch: 'id',

    requete: {},
    grid: [
      {
        header: 'Id',
        accessor: 'id',
        show: false,
      }, {
        header: <strong className={'EurestoPrimary EurestoText--text'}
          style={{ display: 'block', width: '100%' }}>{EurestoI18n.t('commun:Langue')}</strong>,
        accessor: 'libelle',
      }, {
        header: EurestoI18n.t('commun:Icône'),
        accessor: 'icon'
      }
    ],
  },
  [module.COMMUN + '-' + donnee.mail_configuration]: {

    template: ReservationMessage,
    orderBy: ['libelle'],
    modifSearch: 'id',

    requete: {

      get: {
        action: 'get',
        arg: ['id'],
      }
    },
    grid: [
      {
        header: 'Id',
        accessor: 'id',
        show: false,
      }, {
        header: <strong className={'EurestoPrimary EurestoText--text'}
          style={{ display: 'block', width: '100%' }}>{EurestoI18n.t('commun:Type email')}</strong>,
        accessor: 'libelle',
      },
    ],
  },
  [module.COMMUN + '-' + donnee.pays]: {

    orderBy: ['libelle'],
    websocket: true,
    modifSearch: 'id',

    requete: {},
    grid: [
      {
        header: 'Id',
        accessor: 'id',
        show: false,
      }, {
        header: <strong className={'EurestoPrimary EurestoText--text'}
          style={{ display: 'block', width: '100%' }}>{EurestoI18n.t('commun:Pays')}</strong>,
        accessor: 'libelle',
      }, {
        header: EurestoI18n.t('commun:Nationnalité'),
        accessor: 'nationalite'
      }
    ],
  },
  [module.CONFIGURATION + '-' + donnee.profil]: {

    orderBy: ['libelle'],
    template: Profil,
    websocket: true,
    modifSearch: 'id',

    requete: {

      get: {
        action: 'get',
        arg: ['id'],
      },
    },
    grid: [
      {
        header: 'Id',
        accessor: 'id',
        show: false,
      }, {
        header: <strong className={'EurestoPrimary EurestoText--text'}
          style={{ display: 'block', width: '100%' }}>{EurestoI18n.t('commun:Profil')}</strong>,
        accessor: 'libelle',
      }
    ],
  },
  [module.GESTION + '-' + donnee.region_tva]: {

    orderBy: ['libelle'],
    websocket: true,
    modifSearch: 'id',

    requete: {

      get: {
        action: 'get',
        arg: ['id'],
      },
    },
    grid: [
      {
        header: 'Id',
        accessor: 'id',
        show: false,
      }, {
        header: <strong className={'EurestoPrimary EurestoText--text'}
          style={{ display: 'block', width: '100%' }}>{EurestoI18n.t('commun:Région TVA')}</strong>,
        accessor: 'libelle',
      },
    ],
    subComponentLink: 'region_id',
    gridSubComponent: {
      gridObject: module.GESTION + '-' + donnee.taux_tva,
      search: [
        { searchKey: 'region_id', rowKey: 'id' }
      ]
    },

  },
  [module.COMMUN + '-' + donnee.sms_configuration]: {

    template: ReservationMessage,
    orderBy: ['libelle'],
    websocket: true,
    modifSearch: 'id',

    requete: {},
    grid: [
      {
        header: 'Id',
        accessor: 'id',
        show: false,
      }, {
        header: <strong className={'EurestoPrimary EurestoText--text'}
          style={{ display: 'block', width: '100%' }}>{EurestoI18n.t('commun:Email')}</strong>,
        accessor: 'libelle',
      },
    ],
  },
  [module.CRM + '-' + donnee.type_archivage]: {
    orderBy: ['libelle'],
    websocket: true,
    modifSearch: 'id',
  },
  [module.SDD + '-' + donnee.type_action]: {
    orderBy: ['libelle'],
    websocket: true,
    modifSearch: 'id',
  },
  [module.RESTAURANT + '-' + donnee.motif_annulation]: {
    orderBy: ['libelle'],
    websocket: true,
    modifSearch: 'id',
  },
  [module.RESTAURANT + '-' + donnee.motif_refus]: {
    orderBy: ['libelle'],
    websocket: true,
    modifSearch: 'id',
  },
  [module.COMMUN + '-' + donnee.type_media]: {
    orderBy: ['libelle'],
    websocket: true,
    modifSearch: 'id',
  },
  [module.COMMUN + '-' + donnee.media]: {
    orderBy: ['libelle'],
    websocket: true,
    modifSearch: 'id',
  },
  [module.SDD + '-' + donnee.info_tiers]: {
    orderBy: ['libelle'],
    template: MsgInfoTiers,
    websocket: true,
    modifSearch: 'id',
  },
  [module.SDD + '-' + donnee.info_tiers_donnees]: {

    orderBy: ['libelle'],
    template: MsgInfoTiersDonnees,
    websocket: true,
    modifSearch: 'id',

    requete: {

      get: {
        action: 'get',
        arg: ['id'],
      },
    },
    grid: [
      {
        header: 'Id',
        accessor: 'id',
        show: false,
      }, {
        header: <strong className={'EurestoPrimary EurestoText--text'}
          style={{ display: 'block', width: '100%' }}>{EurestoI18n.t('commun:Critère - Donnée')}</strong>,
        accessor: 'libelle',
      },
    ]
  },

  [module.RESTAURANT + '-' + donnee.produit]: {

    orderBy: ['libelle'],
    template: ReservationProduit,
    websocket: true,
    modifSearch: 'id',

    requete: {

      get: {
        action: 'get',
        arg: ['id'],
      },
    },
    grid: [
      {
        header: 'Id',
        accessor: 'id',
        show: false,
      }, {
        header: <strong className={'EurestoPrimary EurestoText--text'}
          style={{ display: 'block', width: '100%' }}>{EurestoI18n.t('commun:Restaurant')}</strong>,
        accessor: 'libelle',
      }, {
        header: EurestoI18n.t('commun:Emails notifiables'),
        accessor: 'adresses_mail_retour',
      },
    ],
    subComponentLink: 'produit_id',
    gridSubComponent: {
      gridObject: module.RESTAURANT + '-' + donnee.service,
      search: [
        { searchKey: 'produit_id', rowKey: 'id' },
      ]
    },

  },
  [module.RESTAURANT + '-' + donnee.service]: {

    orderBy: ['libelle'],
    template: ReservationService,
    websocket: true,
    modifSearch: 'id',

    requete: {

      get: {
        action: 'get',
        arg: ['id'],
      },
    },
    grid: [
      {
        header: 'Id',
        accessor: 'id',
        show: false,
      }, {
        header: <strong className={'EurestoPrimary EurestoText--text'}
          style={{ display: 'block', width: '100%' }}>{EurestoI18n.t('commun:Service')}</strong>,
        accessor: 'libelle',
      }, {
        header: EurestoI18n.t('commun:Ordre'),
        accessor: 'ordre',
        width: 60,
      },
    ]
  },
  [module.RESTAURANT + '-' + donnee.reservation]: {
    orderBy: ['libelle'],
    websocket: true,
    modifSearch: 'id',
  },

  [module.RESTAURANT + '-' + donnee.table_categorie]: {

    orderBy: ['libelle'],
    template: ReservationTableCategorie,
    websocket: true,
    modifSearch: 'id',

    requete: {
      get: {
        action: 'get',
        arg: ['id'],
      },
    },
    grid: [
      {
        header: 'Id',
        accessor: 'id',
        show: false,
      }, {
        header: <strong className={'EurestoPrimary EurestoText--text'}
          style={{
            display: 'block',
            width: '100%'
          }}>{EurestoI18n.t('commun:Catégorie de table')}</strong>,
        accessor: 'libelle',
      },
    ],
    subComponentLink: 'categorie_id',
    gridSubComponent: {
      gridObject: module.RESTAURANT + '-' + donnee.table,
      search: [
        { searchKey: 'categorie_id', rowKey: 'id' },
      ]
    },

  },
  [module.RESTAURANT + '-' + donnee.table]: {
    orderBy: ['libelle'],
    template: ReservationTable,
    websocket: true,
    modifSearch: 'id',

    requete: {

      get: {
        action: 'get',
        arg: ['id'],
      },
    },
    grid: [
      {
        header: 'Id',
        accessor: 'id',
        show: false,
      }, {
        header: <strong className={'EurestoPrimary EurestoText--text'}
          style={{ display: 'block', width: '100%' }}>{EurestoI18n.t('commun:Table')}</strong>,
        accessor: 'libelle',
      }
    ]
  },
  [module.RESTAURANT + '-' + donnee.carcasse]: {
    orderBy: ['libelle'],
    template: ReservationCarcasse,
    websocket: true,
    modifSearch: 'id',

    requete: {

      get: {
        action: 'get',
        arg: ['id'],
      },
    },
    grid: [
      {
        header: 'Id',
        accessor: 'id',
        show: false,
      }, {
        header: <strong className={'EurestoPrimary EurestoText--text'}
          style={{ display: 'block', width: '100%' }}>{EurestoI18n.t('commun:Carcasse')}</strong>,
        accessor: 'libelle',
      }
    ]
  },
}

const typeProduit = {
  ProduitALaVente: 1,
  FicheTechniqueALAVente: 2,
  ProduitEnStockeNonVendus: 3,
  ProduitCave: 4,
  FicheTechniqueDeBase: 5,
}

const themeUI = {
  1: 'default',
  2: 'orange-black',
  3: 'blue-black',
  //4: 'white',
  //5: 'white-orange',
  6: 'ultraviolet-moutarde',
  7: 'flat',
  //8: 'flat1',
  //9: 'flat2',
  //10: 'flat3',
  //11: 'flat4',
}

const methods = {
  GESTION: 'gestion',
  CRM: 'crm',
  RESTAURANT: 'restaurant',
  FIDELITE: 'fidelite',
  SDD: 'sdd',
  INTERFACE: 'interface',
  FACTURATION: 'facturation',
  HOTEL: 'hotel',
  SMS: 'sms'
}

const options = {
  [methods.GESTION]: {
    id: 1030,
    DBM: {
      id: 1031,
      method: 'dbm'
    },
    VIN: {
      id: 1032,
      method: 'vin'
    }
  },
  [methods.RESTAURANT]: {
    id: 1060,
    DONNEES_ANNEXES: {
      id: 151,
      method: 'donnees_annexes'
    },
    MENU: {
      id: 152,
      method: 'menu'
    },
    NOTIFICATION_SMS: {
      id: 153,
      method: 'notification_sms'
    },
    NOTIFICATION_EMAIL: {
      id: 154,
      method: 'notification_email'
    },
    NOTIFICATION_REFUS: {
      id: 155,
      method: 'notification_refus'
    },
    NOTIFICATION_DEMANDE: {
      id: 156,
      method: 'notification_demande'
    },
    NOTIFICATION_CONFIRMATION: {
      id: 157,
      method: 'notification_confirmation'
    },
    NOTIFICATION_ANNULATION: {
      id: 158,
      method: 'notification_annulation'
    },
    FAIT_MAISON: {
      id: 159,
      method: 'fait_maison'
    },
    PAIEMENT: {
      id: 160,
      method: 'restaurant_paiement'
    },
    PORTABLE_VERIFICATION: {
      id: 162,
      method: 'portable_verification'
    }
  },
  [methods.FACTURATION]: {
    id: 1010
  },
  [methods.FIDELITE]: {
    id: 200
  },
  [methods.PEDAGOGIE]: {
    id: 1040
  },
  [methods.HOTEL]: {
    id: 1020,
  },
  [methods.SMS]: {
    id: 950,
    INTERATIONAL: {
      id: 951,
      method: 'sms_international'
    },
    BLOQUE: {
      id: 952,
      method: 'sms_international'
    },
    PACK100: {
      id: 953,
      method: 'sms_pack_100'
    },
    PACK250: {
      id: 954,
      method: 'sms_pack_250'
    },
    PACK500: {
      id: 955,
      method: 'sms_pack_500'
    },
    PACK1000: {
      id: 956,
      method: 'sms_pack_1000'
    },
    PACK1500: {
      id: 957,
      method: 'sms_pack_1500'
    },
    PACK2000: {
      id: 958,
      method: 'sms_pack_2000'
    },
  },
  [methods.INTERFACE]: {
    id: 3000,
    ABILL: {
      id: 3040,
      method: 'abill'
    },
    GUESTONLINE: {
      id: 3061,
      method: 'guestonline'
    },
    ALLIANCE_RESEAUX: {
      id: 3011,
      method: 'alliance_reseaux'
    },
    ZEROSIX: {
      id: 3051,
      method: 'zerosix'
    },
    CENTRALPAY: {
      id: 3081,
      method: 'paiement'
    },
    VINISTORIA: {
      id: 3070,
      method: 'vinistoria'
    },
    SELLSY: {
      id: 3900,
      method: 'sellsy'
    },
    SESAME: {
      id: 3111,
      method: 'sesame'
    },
    OTA: {
      id: 3001,
      method: 'ota'
    },
  },
  [methods.OTA]: {
    id: 3001,
    method: 'ota',
    RESERVIT: {
      id: 3002,
      method: 'reservit'
    },
    DEDGE: {
      id: 3003,
      method: 'dedge'
    },
    NOVARESA: {
      id: 3004,
      method: 'novaresa'
    },
  },
  [methods.SYNCHRONISATION]: {
    id: 1500,
    MOBILE: {
      id: 1501,
      method: 'mobile'
    },
    CRM: {
      id: 1502,
      method: 'crm'
    },
    RESERVATION: {
      id: 1503,
      method: 'reservation'
    },
    PAIEMENT: {
      id: 1504,
      method: 'paiement'
    },
    GESTION: {
      id: 1505,
      method: 'gestion'
    },
  }
};

const typeDocumentStock = {
  INVENTAIRE: 1, //--- Saisie d'inventaire
  BON: 10, //--- Bon de mouvement divers
  COMMANDE: 50, //--- Commande fournisseur
  LIVRAISON: 55, //--- Livraison fournisseur
  //COMMANDE_ARCHIVEE: 51, //--- Commande fournisseur archivée
  //LIVRAISON_ARCHIVEE: 56, //--- Livraison fournisseur archivée
  //PREPARATION: 60, //--- Préparation de produits à la vente
  //VENTE_NOTE: 70, //--- Note en cours
  //VENTE_FACTURE: 80, //--- Facture
  //FT_MAJ: 90, //--- Maj des stocks des produits des fiches techniques
  //DBM: 100, //--- Maj des stocks des produits depuis DBM
  //DBM_ARCHIVE: 101, //--- Si annulation des sorties réeeles on conserve le document initial pou contrôles éventuels (pbl chez Ducasse)
  //Création DEVIS => CHÊNE BLEU
  //CLIENT_COMMANDE: 200, //--- Stock sorties prévisionnelles commande d'un client
  //CLIENT_LIVRAISON: 201, //--- Stock sorties validées livraison commande d'un client
  //MEMO: 301, //--- Mémorisation info produits (coût de revient)
}

const typeMouvementStock = {
  [typeDocumentStock.BON]: [10, 20, 40],
  [typeDocumentStock.INVENTAIRE]: [30, 31],
  [typeDocumentStock.COMMANDE]: [50],
  [typeDocumentStock.LIVRAISON]: [55],
  // [51/*typeDocumentStock.COMMANDE_ARCHIVEE*/]: [51],
  // [56/*typeDocumentStock.LIVRAISON_ARCHIVEE*/]: [56],
  // [60/*typeDocumentStock.PREPARATION*/]: [60],
  // [70/*typeDocumentStock.VENTE_NOTE*/]: [70, 71],
  // [100/*typeDocumentStock.DBM*/]: [100, 110],
  // [101/*typeDocumentStock.DBM_ARCHIVE*/]: [111],
  // [200/*typeDocumentStock.CLIENT_COMANDE*/]: [200],
  // [201/*typeDocumentStock.CLIENT_LIVRAISON*/]: [201],
  // [301/*typeDocumentStock.MEMO*/]: [301],
}

export default {
  access,
  lang,
  license,
  broadcastAction,
  typeSaisie,
  dataType,
  dataObject,
  typeAction,
  relation,
  usefullObjectStatic,
  text2img,
  typeProduit,
  themeUI,
  module,
  donnee,
  methods,
  options,
  typeDocumentStock,
  typeMouvementStock,
}


// WEBPACK FOOTER //
// ./app/Utilitaire/Function/Constants.js